import React, { useEffect } from "react";

import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

import useDecodedParams from "Hooks/useDecodedParams";
import useInput from "Hooks/useInput";
import { organizationByDescriptionIdSelector } from "Reducers/organization/organization";
import {
  addVoucher,
  getVouchers,
  initForm,
  addVoucherErrorsSelector,
  addVoucherLoadingSelector,
  addVoucherStatusSelector
} from "Reducers/voucher";
import { useAppDispatch, useAppSelector } from "Store/hooks";

import * as S from "./Form.styles";

const Form = ({ cancelable = true, reloadList = false }) => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { organizationId } = useDecodedParams<{ organizationId: string }>();

  const organization = useAppSelector(state =>
    organizationByDescriptionIdSelector(state, {
      organizationDescriptionId: organizationId
    })
  );
  const loading = useAppSelector(state => addVoucherLoadingSelector(state));
  const errors = useAppSelector(state => addVoucherErrorsSelector(state));
  const status = useAppSelector(state => addVoucherStatusSelector(state));

  const { inputs, handleInputChange } = useInput({
    code: ""
  });

  useEffect(() => {
    dispatch(initForm());
  }, [dispatch]);

  useEffect(() => {
    if (status === "added") {
      if (reloadList) {
        dispatch(getVouchers({ organization }));
      } else {
        navigate(`/${organizationId}/-/billing/vouchers`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization, status]);

  const handleSave = (e: React.MouseEvent) => {
    e?.preventDefault();
    if (!inputs.code && !organization) return;
    dispatch(addVoucher({ organization, code: inputs.code }));
  };

  return (
    <S.Wrapper>
      <S.Content>
        <S.Input
          id="code"
          name="code"
          label={intl.formatMessage({ id: "voucher.form.code" })}
          placeholder={intl.formatMessage({ id: "voucher.form.code" })}
          onChange={elt => {
            handleInputChange(elt);
          }}
          required={true}
          error={errors}
          value={inputs.code}
          width="100%"
        />

        <S.ButtonWrapper>
          <S.Button
            analyticId="voucher.form.submit"
            onClick={handleSave}
            disabled={loading || inputs?.code.length < 3}
          >
            {intl.formatMessage({ id: "voucher.form.submit" })}
          </S.Button>
          {cancelable && (
            <S.GrowButton
              variant="secondary"
              to={`/${organizationId}/-/billing/vouchers`}
              analyticId="cancel"
            >
              {intl.formatMessage({ id: "cancel" })}
            </S.GrowButton>
          )}
        </S.ButtonWrapper>
      </S.Content>
    </S.Wrapper>
  );
};

export default Form;
